<template >
    <div class="table-title">
        <div class="table-info" v-for="(item,index) in tableInfo" :key="index">
            <p  class="info-title" :class="(item.title=='中药组成'||item.title=='临床表现')?'list-tr':''">{{ item.title }}</p>
            <div v-for="(list,num) in item.list" :key="num">
                <div class="info-list" :class="item.title=='中药组成'?'list-tcm':(item.title=='临床表现'?'list-width':'')"  v-html="list "></div>
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    props:['tableInfo']
}
</script>
<style lang="">
    
</style>